import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { fetchManufacturers, selectManufacturers } from '@client/manufacturer/redux/manufacturers/redux';
import { ManufacturersType } from '@client/manufacturer/redux/manufacturers/types';

export const useManufacturersEffect = (
  query?: string,
  filter?: string,
): RemoteRecord<ManufacturersType> => {
  const dispatch = useDispatch();
  const manufacturers = useSelector(selectManufacturers);

  useEffect(
    (): void => {
      dispatch(fetchManufacturers({ query, filter }));
    },
    [filter, query],
  );

  return manufacturers;
};
